import { render } from "./NpiForm.vue?vue&type=template&id=051a2a92"
import script from "./NpiForm.vue?vue&type=script&lang=js"
export * from "./NpiForm.vue?vue&type=script&lang=js"

import "./NpiForm.vue?vue&type=style&index=0&id=051a2a92&lang=scss"
script.render = render

export default script